<template>
  <div>
    <el-tabs v-model="active" type="border-card">
      <el-tab-pane label="待调度" name="D">
        <page-dispatch v-if="active === 'D'" />
      </el-tab-pane>
      <el-tab-pane label="已调度" name="S">
        <page-scheduled v-if="active === 'S'" />
      </el-tab-pane>
      <el-tab-pane label="运输单" name="W">
        <page-waybill v-if="active === 'W'" />
      </el-tab-pane>
      <el-tab-pane label="已派单" name="A">
        <page-assign v-if="active === 'A'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PageDispatch from './components/dispatch/table'
import PageScheduled from './components/scheduled/table'
import PageWaybill from './components/waybill/table'
import PageAssign from './components/assign/table'
export default {
  name: 'carriage-dispatch',
  components: {
    PageDispatch,
    PageScheduled,
    PageWaybill,
    PageAssign,
  },
  data() {
    return {
      table: [],
      loading: false,
      active: 'D',
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped></style>
